export default __webpack_public_path__ + "static/doc-verification-step-3-9781b734e8709b131d33db3b657d2da9.svg";